/**
 * Layout helpers for the Filter Students form (pure — no React).
 */

import {
  PRIMARY_FILTER_FIELD,
  filterFieldsForUserType,
  filterProfileForUserType,
} from './filterProfiles';

/**
 * @param {Record<string, unknown>} [filters]
 * @returns {string}
 */
export function selectedFilterUserType(filters = {}) {
  const role = filters.role;
  if (Array.isArray(role)) return String(role[0] || '').trim();
  return role == null ? '' : String(role).trim();
}

/**
 * @param {Array<{ name?: string, category?: string, multiSelect?: boolean }>} fields
 */
export function splitPrimaryFilterField(fields) {
  const list = fields || [];
  const primary = list.find((field) => field.name === PRIMARY_FILTER_FIELD);
  const rest = list.filter((field) => field.name !== PRIMARY_FILTER_FIELD);
  return {
    primaryField: primary ? { ...primary, multiSelect: false } : null,
    rest,
  };
}

/**
 * @param {Array<{ name?: string, category?: string }>} fields
 * @param {unknown} role
 */
export function buildFilterFormLayout(fields, role) {
  const visible = filterFieldsForUserType(fields, role);
  const { primaryField, rest } = splitPrimaryFilterField(visible);
  const profile = filterProfileForUserType(role);
  const additionalSet = new Set(profile.additionalCategories);
  const groups = {};
  for (const field of rest) {
    const category = field.category || 'general';
    if (!groups[category]) groups[category] = [];
    groups[category].push(field);
  }
  const mainCategories = [];
  const additionalCategories = [];
  for (const category of profile.categories) {
    if (!groups[category]) continue;
    if (additionalSet.has(category)) additionalCategories.push(category);
    else mainCategories.push(category);
  }
  return { primaryField, groups, mainCategories, additionalCategories };
}

/**
 * Drop filter keys that are hidden for the selected User Type.
 * @param {Record<string, unknown>} filters
 * @param {Array<{ name?: string, category?: string }>} fields
 * @param {unknown} role
 */
export function pruneFiltersForUserType(filters, fields, role) {
  const allowed = new Set(
    filterFieldsForUserType(fields, role).map((field) => field.name)
  );
  allowed.add(PRIMARY_FILTER_FIELD);
  const next = {};
  for (const [key, value] of Object.entries(filters || {})) {
    if (allowed.has(key)) next[key] = value;
  }
  next[PRIMARY_FILTER_FIELD] = Array.isArray(role) ? role[0] || '' : role || '';
  if (next[PRIMARY_FILTER_FIELD] === '') delete next[PRIMARY_FILTER_FIELD];
  return next;
}
